var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup4273201971(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "#234492"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2166 5.33327H10.0009C9.81329 4.42095 9.01075 3.76582 8.07934 3.76465H7.29502C6.3636 3.76582 5.56107 4.42095 5.37346 5.33327H4.15778C3.94119 5.33327 3.76562 5.50884 3.76562 5.72542C3.76562 5.942 3.94119 6.11759 4.15778 6.11759H4.54993V11.2156C4.55123 12.298 5.42835 13.1751 6.51072 13.1764H8.86366C9.94603 13.1751 10.8231 12.298 10.8244 11.2156V6.11759H11.2166C11.4332 6.11759 11.6088 5.94202 11.6088 5.72544C11.6088 5.50886 11.4332 5.33327 11.2166 5.33327ZM7.29504 10.4313C7.29504 10.6479 7.11947 10.8235 6.90289 10.8235C6.68629 10.8235 6.51072 10.6479 6.51072 10.4313V8.07838C6.51072 7.8618 6.68629 7.68623 6.90287 7.68623C7.11945 7.68623 7.29502 7.8618 7.29502 8.07838V10.4313H7.29504ZM8.86366 10.4313C8.86366 10.6479 8.68809 10.8235 8.47151 10.8235C8.25493 10.8235 8.07936 10.6479 8.07936 10.4313V8.07838C8.07936 7.8618 8.25493 7.68623 8.47151 7.68623C8.68809 7.68623 8.86366 7.8618 8.86366 8.07838V10.4313ZM6.18563 5.33327C6.35243 4.86358 6.79662 4.54956 7.29504 4.54895H8.07936C8.57778 4.54956 9.02197 4.86358 9.18877 5.33327H6.18563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4273201971);
export default __webpack_public_path__ + "static/media/Group 427320197 (1).1d1f6e450baa6a927439da1da4a864c1.svg";
export { ForwardRef as ReactComponent };